import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class CustomTextService extends ApiService {
  public eventEmitter = new EventEmitter();
  public getCustomTextsList(param): Observable<any> {
    return this.request({
      path: 'reports/report-configs',
      method: 'GET',
      query: param
    });
  }

   public deleteCustomText(id): Observable<any> {
    return this.request({
      path: `reports/report-configs/${id}`,
      method: 'DELETE',
    });
  }




     public updateCustomTexts(data): Observable<any> {
      return this.request({
        path: `reports/report-configs`,
        method: 'POST',
        body: data
      });
    }


}
